module.exports = __webpack_public_path__ + "static/media/TN-Women-Tops-2.1_OptionAll.84fc322f.svg";